import PropTypes from 'prop-types';
import styles from './SingleSearchGun.module.css';


const SingleSearchGun = ({title, img}) => {
    return (
        <div className={styles.singleSearchGun}>
            <div className={styles.imgWrapper}>
                <img src={img} alt="" />
            </div>
            <p>{title}</p>
        </div>
    );
};

export default SingleSearchGun;

//type checking 
SingleSearchGun.propTypes = {
    title: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
}